import { render, staticRenderFns } from "./ReferralsCrudIndex.vue?vue&type=template&id=596c816c&scoped=true&"
import script from "./ReferralsCrudIndex.vue?vue&type=script&lang=js&"
export * from "./ReferralsCrudIndex.vue?vue&type=script&lang=js&"
import style0 from "./ReferralsCrudIndex.vue?vue&type=style&index=0&id=596c816c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596c816c",
  null
  
)

export default component.exports